import React from 'react';
import {
  Box,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export type FailedProps = {
  pds_id: number;
  device_id: string | null;
  equipment_id: string | null;
  error: string;
  service_point_customer_id: string | null;
};

type RejectionModalProps = {
  open: boolean;
  invalidData: FailedProps[];
  onClose: () => void;
};

export default function CreationErrorsModal({ open, invalidData, onClose }: RejectionModalProps) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          minWidth: 600,
          borderRadius: 1
        }}
      >
        <Box
          sx={{
            maxHeight: '60vh',
            overflowY: 'auto',
            '&::-webkit-scrollbar': { WebkitAppearance: 'none', width: '6px' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,.5)', borderRadius: '3px' }
          }}
        >
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{t('bconnectMaintenanceOrder.pdsSelection.pdsListing.pds')}</TableCell>
                <TableCell>
                  {t('bconnectMaintenanceOrder.pdsSelection.pdsListing.sensor')}
                </TableCell>
                <TableCell>
                  {t('bconnectMaintenanceOrder.pdsSelection.pdsListing.module')}
                </TableCell>
                <TableCell sx={{ minWidth: 400 }}>
                  {t('bconnectMaintenanceOrder.errorDescription')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invalidData.map((item: FailedProps, index: number) => {
                return (
                  <TableRow key={index}>
                    <TableCell>
                      {item.service_point_customer_id ?? item.service_point_customer_id}
                    </TableCell>
                    <TableCell>{item.equipment_id ?? item.equipment_id}</TableCell>
                    <TableCell>{item.device_id ?? item.device_id}</TableCell>
                    <TableCell>{item.error}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
        <Button onClick={onClose} sx={{ display: 'block', margin: '16px auto 0' }}>
          {t('bconnectMaintenanceOrder.pdsSelection.pdsListing.close')}
        </Button>
      </Box>
    </Modal>
  );
}
